import { render, staticRenderFns } from "./RozaTable.vue?vue&type=template&id=fe4cb5a8&"
import script from "./RozaTable.vue?vue&type=script&lang=js&"
export * from "./RozaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports